__webpack_require__.p = "/goit-59-fs/";